import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules'; // Autoplay import

const Product = () => {
  const product = [
    { name: 'Machine Integration & M2M Connectivity', image: '/images/projects/Machine-inte.png' },
    { name: 'Industrial IoT & Digitalization Solutions', image: '/images/projects/Industrial.png' },
    { name: 'Real-Time Data Acquisition & Analytics', image: '/images/projects/Real-Time.png' },
    { name: 'Automation & Control Engineering', image: '/images/projects/Auto.png' },
    { name: 'Control Panel Design & System Upgrades', image: '/images/projects/Control.png' },
    { name: 'Energy & Utility Monitoring Systems', image: '/images/projects/Energy.png' },
    { name: 'Robotics & Advanced Automation Integration', image: '/images/projects/Robotics.png' }
  ];

  return (
    <section id="work" className="section" style={{ backgroundColor: '#121212' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className="font-weight-600 mb-3 text-white">We Provide Smart & Innovative Solutions</h2>
            <hr className="heading-separator-line border-primary border-2 d-block mx-auto" />
            <p className="text-4 mb-5" style={{ color: '#CCCCCC' }}>
              We provide innovative, end-to-end solutions designed to solve real business challenges. 
              Our approach combines modern technology, smart automation, and industry expertise to deliver 
              reliable, scalable, and future-ready results that help organizations improve efficiency, reduce 
              costs, and accelerate digital growth.
            </p>
          </div>
        </div>

        {/* Swiper Slider */}
        <Swiper
  modules={[Navigation, Pagination, Autoplay]}
  navigation
  pagination={{ clickable: true }}
  spaceBetween={20}
  slidesPerView={4}
  breakpoints={{
    0: { slidesPerView: 1 },
    576: { slidesPerView: 2 },
    768: { slidesPerView: 3 },
    1024: { slidesPerView: 4 }
  }}
  grabCursor={true}
  freeMode={true}
  loop={true}
  autoplay={{
    delay: 0,           // immediate continuous movement
    disableOnInteraction: false,
  }}
  speed={2000}           // jitna bada number, utni slow and smooth movement
>

          {product.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="product-card"
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  borderRadius: '15px',
                  width: '100%',
                  height: '300px',
                }}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: '600',
                    fontSize: '1.2rem',
                    textAlign: 'center',
                    background: 'rgba(0,0,0,0.4)',
                    padding: '10px',
                  }}
                >
                  {item.name}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Product;
